<template>
  <myhead @next="next">{{ $route.query.title || $route.meta.title }}</myhead>
  <van-tabs v-model:active="active" title-active-color="#3F7C93" @click-tab="handleTab" >
    <van-tab title="普通配送">
      <div class="flex between center address" @click="
          $router.push({
            path: '/address',
            query: { title: '收货地址', type: 'auction',order_id:order_id},
          })
        " v-if="!addressInfo">
        <div class="size14">添加收货地址</div>
        <img src="@/assets/img/icon35.png" class="address__arr" />
      </div>
      <div class="flex between center address" v-else @click="
          $router.push({
            path: '/address',
            query: { title: '收货地址', type: 'auction',order_id:order_id },
          })
        ">
        <div class="size14 address-left ">
          <p class="flex mb10"> <span class="address_name">{{ addressInfo.consignee }}</span> {{ addressInfo.mobile }}</p>
          <p>
            <van-icon name="location-o" class="mr5" size="14" />{{ addressInfo.streetstr }} {{ addressInfo.address }}
          </p>
        </div>
        <img src="@/assets/img/icon35.png" class="address__arr" />
      </div>
    </van-tab>
    <van-tab title="上门自提">
      <div class="flex between center address">
        <div class="flex between address-txt size14 address-left width80 ">
          <div class="ellipsis2 mb10 ">
            <van-icon name="location-o" class="mr5" size="14" />
            {{ stores.province }}{{ stores.city }}{{ stores.district }}{{ stores.pickup_address }}
          </div>
          <p class="flex">
            <span class="address_name">{{ stores.pickup_name }}寄11111111111111</span>
            <span class="address_name" style="width:130px">{{stores.pickup_mobile}}111111111111</span>
          </p>
          <div class="flex address-phone size14" style="flex-direction: inherit; align-items: center;">
            <van-icon name="phone-o" size="14" color="#3F7C93" />
            <p class="weight" style="color:#3F7C93"  @click="handleTel">拨打</p>
          </div>
        </div>
        <p class="address-copy size12 b500" @click="copy">复制地址</p>

      </div>
    </van-tab>
    <van-tab title="定制配送">
      <div class="weight address">
        <p class="size16  a345 mb15">双方商定配送方式执行。</p>
        <div class="flex sp between center address-checked size6">
          <div></div>
          <div class="flex">
            <van-checkbox v-model="checked" checked-color="#3F7C93" icon-size="16px"></van-checkbox>
            <p class="ml8">同意并接受<span @click="handleDelivery" v-if="delivery.delivery_title" class="xycolor">《{{delivery.delivery_title}}》</span></p>
          </div>
        </div>
      </div>
    </van-tab>
  </van-tabs>

  <div style="padding-bottom: 100px">
    <div class="complete" >
      <div class="complete-tle flex">
        <img :src="goodsInfo.head_pic" :onerror="Imgerror" />
        <p class="size14">{{ goodsInfo.goods_name }}</p>
        <!-- {{item.is_show}} -->
      </div>
      <div class=" complete-name">
        <img :src="goodsInfo.original_img" :onerror="Imgerror" />
        <!-- <div class="complete-list size14">
          <div v-for="spec in item.spec" :key="spec.item_id">
            <div class="complete-item size12">
              <p class="flex between center mb5"><span>{{spec.key_name}}</span> <span class="size10">×{{spec.num}}</span></p>
              <div class="flex between center mb10"><span></span>
                <p><span class="size8">￥</span> {{spec.price}}</p>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="complete-cost size12">
        <div class="flex center between">
          <p>商品总价</p>
          <p class="complete-cost-price b500">
            ¥<span>{{ goodsInfo.goods_amount }}</span>
          </p>
        </div>
        <div class="flex center between">
          <p>配送运费</p>
          <p class="complete-cost-price b500">
            ¥<span>{{ goodsInfo.express_amount }}</span>
          </p>
        </div>
        <div class="flex center between">
          <p>实际总付</p>
          <p class="complete-cost-price b500">
            ¥<span class="complete-cost-price-large">{{
              goodsInfo.order_amount
          }}</span>
          </p>
        </div>
      </div>
      <div class="graybar"></div>
      <div class="remake flex between">
        <p>备注</p>
        <div class="remake-textarea">
          <van-field v-model="goodsInfo.remake" placeholder="建议备注前先与卖家达成一致" input-align="right" type="textarea" />
        </div>
      </div>
    </div>
  </div>
  <Tabbar :fn="handleZf" v-model:sum="sum" v-model:total="total"></Tabbar>
  <van-popup v-model:show="deliveryShow" style="width:100%;border-radius:5px">
    <div class="deliverypopup">
      <img src="@/assets/img/icon32.png" class="deliverypopup__close" @click="handleDelivery">
      <p class="b500 size18 mb15 center">{{ delivery.delivery_title }}</p>
      <p v-html="delivery.delivery_content"></p>
    </div>
  </van-popup>

  <van-popup v-model:show="timeshow" :style="{ padding: '10px 25px', width: '90%' }" :round="true">
    <div class="popuptemplate">
      <van-picker title="选择取货时间" :columns="columns" @click-option="handleTimePick" @change="handleChange" @confirm="handleConfirm"
        :swipe-duration="100">
        <template #toolbar>
          <div class="vanpickertop">
            <p>选择取货时间</p>
          </div>
        </template>
        <template #columns-bottom>
          <button class="pick-timeconfirm" @click="closeTimeshow">确定</button>
        </template>
      </van-picker>
      <img src="@/assets/img/icon32.png" class="pickerclose" @click="handleShow" />
    </div>
  </van-popup>
  <PayDialog v-model:showPopup="showPopup" title="支付"  v-model:amount="sum" :nextFn="handlePay">
  </PayDialog>
</template>
<script>
import useClipboard from "vue-clipboard3";
import Tabbar from "./tabbar.vue";
import ajax from "@/utils/request.js";
import PayDialog from "@/components/PayDialog.vue";
import { showToast } from "vant";
export default {
  components: { Tabbar ,PayDialog },
  data () {
    return {
      columns: [],
      order_id:0,
      active: 0,
      addressInfo: {},
      goodsInfo:{},
      stores: {},
      delivery: {},//协议内容
      checked: false, //定制配送条款
      deliveryShow: false,//协议弹窗
      sum: 0,
      total: 1,
      timeshow: false, //自提时间选择
      trade_time: "", //自提时间
      timedata: [], //保存时间
      dateArr: [],//存放自提时间的所有数据的数组
      showPopup: false,//支付页显示状态



      
    };
  },
  created () {
    this.order_id = this.$route.query.order_id
    const address_type =  this.active + 1;
    const data= {
        order_id:this.$route.query.order_id,
        address_type:address_type
      }
      if(this.$route.query.addressid){
       data.address_id = this.$route.query.addressid
        ajax.post("order/auctionorder",data).then(res=>{
          console.log(res);
          if(res.errcode === 1){
            if(res.message != '获取成功'){
              this.showToast(res.message);
            }
            if(res.data.address_info){
              this.addressInfo = res.data.address_info;
            }
            this.goodsInfo = res.data.store_goods;
            this.stores = res.data.stores[0];
            this.sum = res.data.store_goods.order_amount;
            this.delivery.delivery_title = res.data.stores[0].delivery_title
            this.delivery.delivery_content = res.data.stores[0].delivery_content
          }
          
        })
      }else{
        ajax.post("order/auctionorder",data).then(res=>{
          console.log(res);
          if(res.errcode === 1){
            if (!this.$route.query.addressid) {
              this.addressInfo = res.data.address_info;
            }
            if(res.message != '获取成功'){
              this.showToast(res.message);
            }
            this.stores = res.data.stores[0];
            this.goodsInfo = res.data.store_goods;
            this.sum = res.data.store_goods.order_amount;
            this.delivery.delivery_title = res.data.stores[0].delivery_title
            this.delivery.delivery_content = res.data.stores[0].delivery_content
          }
          
        })
      }
      
  },
  methods:{
    // 支付
    async handlePay  (amount, typeid) {
      // const types = this.type == 1 ? 1 : (this.goodsinfo.length > 1) ? 2 : 1
      // 判断跳转路径
      let return_url = location.origin + "/#/shop/order"
      // if (this.type === 1) {
      //   //从商品详情页跳转  跳回详情页
      //   return_url = location.origin + "/#/shop/detail?goods_id=" + this.goodsinfo[0].goods_id
      // }
      const data = {
        typeid: typeid,
        no: this.no,
        return_url: return_url
      };
      ajax.post("pay/pay", data).then((res) => {
        if (res.errcode === 1) {
          window.location.href = res.data.info;
        }
      });
    },
    handleShow () {
      this.timeshow = false;
    },
    //确认时间，关闭弹窗，提交订单
    closeTimeshow () {
      if (this.trade_time == "" || this.trade_time == null) {
        this.trade_time = this.columns[1][0].value
        // this.trade_time = this.columns[0].value
      }
      
      const data = {
        order_id:this.$route.query.order_id,
        address_type: this.active + 1,
        shipping_price:this.goodsInfo.express_amount,
        user_note:this.goodsInfo.remake,
        act: 1,
        trade_time:this.trade_time
      };
      console.log(data);
      this.timeshow = false;
      ajax
        .post("order/auctionorder",data)
        .then((res) => {
          if (res.errcode === 1) {
            const no = res.data.no;
            this.no = no;
            this.showPopup = true;
          }
        });
    },
    //自提时间改变
    handleChange (selectedValues) {
      if (this.timenum !== selectedValues.selectedOptions[0].type) {
        const obj = this.dateArr.find(item => {
          return item.text === selectedValues.selectedValues[0]
        })
        this.columns[1] = obj.value
        this.trade_time = this.columns[1][0].value
        this.timenum = selectedValues.selectedOptions[0].type
      } else {
        this.trade_time = selectedValues.selectedValues[1]
      }
    },
    //协议弹窗
    handleDelivery () {
      this.deliveryShow = !this.deliveryShow
    },
    // 复制地址
    async copy () {
      const { toClipboard } = useClipboard();

      try {
        await toClipboard(
          this.stores.province +
          this.stores.city +
          this.stores.district +
          this.stores.pickup_address
        );
        this.showToast("复制地址成功");
      } catch (e) {
        this.showToast("当前浏览器版本不支持复制，请长按复制");
      }
      // var copyText = document.getElementById("myInput");
      // copyText.select();
      // navigator.clipboard.writeText(copyText.value);
      // this.showToast("复制成功")
    },
    // 拨打电话
    handleTel () {
      window.location.href = "tel://" + this.stores.pickup_mobile;
    },
    handleTab(){
      const address_type =  this.active + 1;
      ajax.post("order/auctionorder",{
        order_id:this.$route.query.order_id,
        address_type:address_type
      }).then(res=>{
        if(res.errcode === 1){
          if(res.message != '获取成功'){
              this.showToast(res.message);
            }
          this.addressInfo = res.data.address_info;
          this.goodsInfo = res.data.store_goods;
          this.sum = res.data.store_goods.order_amount;
          this.stores = res.data.stores[0];
          this.delivery.delivery_title = res.data.stores[0].delivery_title
          this.delivery.delivery_content = res.data.stores[0].delivery_content



           //获取自提时间
           if (this.active == 1) {
              // this.columns
              const data = res.data.stores[0].trade_time;
              this.timedata = res.data.stores[0].trade_time;
              // const dateArr = []
              data.forEach(v => {
                const obj = this.dateArr.find(item => {
                  return item.text === v.title
                })
                if (!obj) {
                  this.dateArr.push({ text: v.title, value: [{ text: v.time, value: v.value }] })
                } else {
                  obj.value.push({ text: v.time, value: v.value })
                }
              })



              //获取第一个时间，初始化时放第一个时间的值
              const time = data[0].title
              //存放左边的时间
              const leftArr = []
              //存放右边的时间的值
              const rightArr = []
              data.forEach((item) => {
                //获取左边的时间
                const leftObj = leftArr.find(lt => {
                  return lt.text === item.title
                })
                if (!leftObj) {
                  leftArr.push({ text: item.title, value: item.title, type: this.timenum })
                }
                this.timenum++
                //获取右边的时间的值
                if (item.title === time) {
                  rightArr.push({ text: item.time, value: item.value, type: 'right' })
                }
                this.suppliers_id = [];
                this.suppliers_id.push({
                  suppliers_id: res.data.stores[0].suppliers_id,
                });
              });
              //初始化时间数组
              this.columns.push(leftArr)
              this.columns.push(rightArr)
              //初始化timenum，后面用于辨别左边时间更换
              this.timenum = 1

            } 
        }
        
      })

    },
    // 支付
    handleZf () {
      const data = {
        order_id:this.$route.query.order_id,
        address_type: this.active + 1,
        shipping_price:this.goodsInfo.express_amount,
        user_note:this.goodsInfo.remake,
        act: 1,
      };
        if (this.active === 0) {
          console.log(data);
          // address_id收货地址id
          if(this.$route.query.addressid){
            data.address_id = this.$route.query.addressid
          }
          ajax
            .post("order/auctionorder", data)
            .then((res) => {
              if (res.errcode === 1) {
                const no = res.data.no;
                this.no = no;
                console.log(this.no);
                this.showPopup = true;
              }
            });
        }
        else if (this.active === 1) {
          //自提支付的情况
          this.timeshow = true;
        } else if (this.active === 2) {
          if (this.checked === false) {
            showToast("请先同意协议");
            return;
          } else {
            data.is_ok = this.goodsInfo.suppliers_id; 
            console.log(data);
            ajax
              .post("order/auctionorder",data)
              .then((res) => {

                if (res.errcode === 1) {
                  const no = res.data.no;
                  this.no = no;
                  console.log(this.no);
                  this.showPopup = true;
                }
              });
          }
        }
    },
    
  }
};
</script>
<style scoped lang="scss">
.xycolor {
  color: blue;
}
.complete {
  padding: 4vw;
  border-radius: 10px;
  background-color: #fff;
}
.complete-tle img {
  width: 4.8vw;
  height: 4.8vw;
  border-radius: 10%;
  object-fit: contain;
  margin-right: 1.0667vw;
}
.complete-tle p {
  color: #333333;
}
.complete-name {
  display: flex;
  margin-top: 2.6667vw;
  img {
    width: 26.6667vw;
    height: 26.6667vw;
    background: #ffffff;
    border-radius: 1.0667vw;
  }
  .complete-list {
    // width: 56.2667vw;
    flex: 1;
    margin-left: 2.6667vw;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
}
.complete-regular {
  padding: 5.3333vw 0;
  .regular-list {
    margin-bottom: 3.2vw;
    &:last-child {
      margin-bottom: 0;
    }
    div {
      width: 20%;
      text-align: right;
      &:first-child {
        text-align: left;
        width: 40%;
        span {
          color: #999999;
          padding: 1.3333vw 5.3333vw;
          // background: #f6f6f6;
          border-radius: 0.5333vw;
        }
      }
      &:nth-child(3) {
        span {
          padding: 1.3333vw 0.8vw;
          // border: 1px solid rgba(204, 204, 204, 0.3);
          border-radius: 0.5333vw;
        }
      }
    }
    span {
      font-size: 16px;
      color: #333333;
      text-align: right;
    }
  }
}
.complete-cost {
  font-size: 14px;
  line-height: 36px;
  .complete-cost-price {
    color: #ff0000;
    span {
      font-size: 12px;
    }
    .complete-cost-price-large {
      font-size: 22px;
    }
  }
}
.graybar {
  width: 100%;
  margin: 0 auto;
  border-bottom: 1px solid #cccccc;
}
.remake {
  align-items: flex-start;
  padding: 2.6667vw 0;
  background-color: #fff;
}
.remake .van-cell {
  padding: 0;
}
.remake-textarea {
  width: 59.7333vw;
}
.address_name{
  display: block;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.address {
  padding: 4vw;
  background-color: #fff;
  margin-top: 2.6667vw;
  margin-bottom: 2.6667vw;
  border-radius: 10px;
  .address__arr {
    width: 4.2667vw;
  }
  .address-copy {
    color: #3f7c93;
  
  }
  .address-txt {
    text-align: left;
  }
  .address-phone {
    flex-direction: column;
    img {
      width: 4.2667vw;
      margin-bottom: 2.6667vw;
    }
    p {
      color: #666666;
      font-size: 14px;
    }
  }
}
.address-left {
  text-align: left;
  p {
    font-size: 14px;
    line-height: 1;
    // &:nth-child(2) {
    //   font-size: 16px;
    //   margin-top: 2.1333vw;
    //   margin-bottom: 2.1333vw;
    // }
  }
}
//弹窗及日期自定义
.vanpickertop {
  width: 100%;
  position: relative;
  p {
    text-align: center;
    font-size: 16px;
    color: #666666;
  }
}
.popuptemplate {
  position: relative;
}
.pickerclose {
  position: absolute;
  width: 3.7333vw;
  height: 3.7333vw;
  right: -11px;
  top: 0;
}
.pick-timeconfirm {
  width: 100%;
  height: 9.6vw;
  line-height: 9.6vw;
  text-align: center;
  background: #3f7c93;
  border-radius: 21px;
  margin: 0 auto;
  font-size: 14px;
  color: #ffffff;
}
//支付弹窗
.paydialog {
  position: relative;
  width: 100%;
  padding: 4.2667vw 4.2667vw 5.3333vw;
  .paydialog__close {
    position: absolute;
    top: 3.4667vw;
    right: 3.4667vw;
    width: 3.7333vw;
    height: 3.7333vw;
  }
  .paydialog__img {
    display: block;
    width: 13.8667vw;
    height: 13.8667vw;
    margin: 6.6667vw auto 0;
  }
  .paydialog-success {
    text-align: center;
    font-size: 22px;
    color: #3f7c93;
    margin-top: 5.6vw;
    margin-bottom: 9.3333vw;
    letter-spacing: 1px;
  }
  .paydialog-code {
    text-align: center;
    font-size: 14px;
    color: #3f7c93;
    letter-spacing: 1px;
    span {
      color: #333333;
    }
  }
  .paydialog-tip {
    text-align: center;
    font-size: 12px;
    color: #ff0000;
    text-align: center;
    margin-top: 3.2vw;
    margin-bottom: 10.6667vw;
  }
  .paydialog-btn {
    button {
      width: 34.6667vw;
      height: 10.6667vw;
      line-height: 10.6667vw;
      text-align: center;
      background: #f6f6f6;
      border-radius: 5.8667vw;
      color: #666666;
      font-size: 14px;
      &:last-child {
        background: #3f7c93;
        color: #ffffff;
      }
    }
  }
}
.deliverypopup {
  padding: 5.3333vw;
  position: relative;
}
.deliverypopup__close {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 15px;
  height: 15px;
}
.paydialog .paydialog-btn .btngray {
  color: #d9d9d9;
}
</style>
<style>
/* .van-picker__columns {
  height: 198px !important;
  margin-bottom: 22px;
}
.van-picker-column__wrapper {
  margin-top: -88px;
}
.van-picker__mask {
  background-image: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.6),
      rgba(255, 255, 255, 0.4)
    ),
    linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.4));
  background-size: 100% 100% !important;
  background-position-y: 66px;
} */
</style>